import * as React from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { useEventDialogStyledContext } from "./EventDialogStyledContext.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EventDialogHeaderRoot = styled('header', {
  name: 'MuiEventDialog',
  slot: 'Header'
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1.5),
  padding: theme.spacing(3),
  cursor: 'move'
}));
export default function EventDialogHeader(props) {
  const {
    children,
    onClose,
    dragHandlerRef
  } = props;
  const {
    classes,
    localeText
  } = useEventDialogStyledContext();
  return /*#__PURE__*/_jsxs(EventDialogHeaderRoot, {
    ref: dragHandlerRef,
    className: classes.eventDialogHeader,
    children: [children, /*#__PURE__*/_jsx(IconButton, {
      className: classes.eventDialogCloseButton,
      "aria-label": localeText.closeButtonAriaLabel,
      onClick: onClose,
      children: /*#__PURE__*/_jsx(CloseRounded, {})
    })]
  });
}